// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BaseFloatingPicker_callout_31JuF .ms-Suggestions-itemButton {\n  padding: 0px;\n  border: none; }\n\n.BaseFloatingPicker_callout_31JuF .ms-Suggestions {\n  min-width: 300px; }\n", ""]);
// Exports
exports.locals = {
	"callout": "BaseFloatingPicker_callout_31JuF"
};
module.exports = exports;
